<template>
  <div class="registeredPlane" v-if="registShow">
    <!-- <div class="left">
      <img src="../assets/images/home/loginBG.png" />
    </div> -->
    <div class="registered">
      <div>
        <i @click="clsoeRegist" class="el-icon-close"></i>
      </div>
      <div class="logo">
        <img :src="logo" />
      </div>
      <el-form :model="formList" ref="formList" :rules="rules">
        <el-form-item prop="mobile">
          <div class="leftItem">
            <div class="icon-bk">
              <i class="el-icon-phone left-icon"></i>
            </div>
            <el-input :placeholder="$t('LoginObj.PleaseNumber')" v-model="formList.mobile"></el-input>
          </div>
        </el-form-item>

        <el-form-item prop="password">
          <div class="leftItem">
            <div class="icon-bk">
              <i class="el-icon-lock left-icon"></i>
            </div>
            <el-input type="password" :placeholder="$t('LoginObj.PleasePassword')" v-model="formList.password"></el-input>
          </div>
        </el-form-item>

        <el-form-item prop="password2">
          <div class="rightItem">
            <div class="icon-bk">
              <i class="el-icon-lock left-icon"></i>
            </div>
            <el-input type="password" :placeholder="$t('LoginObj.PleaseAgain')" v-model="formList.password2"></el-input>
          </div>
        </el-form-item>

        <el-form-item prop="code" :rules="[{required: true, message: $t('LoginObj.PleaseCode')}]">
          <div class="rightItem">
            <el-input
              class="code-input"
              :placeholder="$t('LoginObj.PleaseCode')"
              v-model="formList.code"
              maxlength="10"
            ></el-input>
            <el-button
              v-if="isSendCode"
              @click="verificationCodeEvent"
              class="verificationCodeBtn"
              :disabled="isSendCode"
            >{{this.isNumber+'s'+$t('LoginObj.Reacquire')}}</el-button>
            <el-button
              v-else
              @click="verificationCodeEvent"
              class="verificationCodeBtn"
              :disabled="isSendCode"
            >{{$t('LoginObj.GetVerificationCode')}}</el-button>
          </div>
        </el-form-item>

        <div class="handleBox">
          <el-button v-if="registType === 1" class="handle" @click="regisTeredEvent">{{$t('LoginObj.SignUpNow')}}</el-button>
          <el-button v-if="registType === 2" class="handle" @click="regisTeredEvent">{{$t('LoginObj.ImmediatelyFind')}}</el-button>
          <el-button v-if="registType === 3" class="handle" @click="regisTeredEvent">{{$t('LoginObj.ChangePassword')}}</el-button>
        </div>

        <div class="foot-login" v-if="registType === 1">
          <span>
            {{$t('LoginObj.ExistingAccount')}}?
            <a @click="toLogin" class="curter">{{$t('LoginObj.LogIn')}}</a>
          </span>
          <span class="forget-password">
            <el-checkbox v-model="radio">
              <a @click="termsOfServiceEvent">{{$t('LoginObj.AgreeDisclaimer')}}</a>
            </el-checkbox>
            <!-- <router-link to='#'>同意会员条款和免责声明</router-link> -->
          </span>
        </div>
        <!-- <div class='a-click'>
                <a>忘记密码</a>&nbsp &nbsp &nbsp &nbsp |&nbsp &nbsp&nbsp &nbsp  <a> 注册</a>
        </div>-->
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  messageAuthentication,
  userRegister,
  forgotPassword
} from '@/api/login'

export default {
  props: ['registShow', 'registType', 'logo'],
  data () {
    var checkPhone = (rule, value, callback) => {
      if (this.formList.mobile === '') {
        callback(new Error(this.$t('LoginObj.PleaseNumber')))
      } else if (this.formList.mobile.match(/^1[34578]\d{9}$/) === null) {
        callback(new Error(this.$t('LoginObj.PleaseNumber')))
      } else {
        callback()
      }
    }
    var validatePass = (rule, value, callback) => {
      if (this.formList.password === '') {
        callback(new Error(this.$t('LoginObj.PleasePassword')))
      } else {
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (this.formList.password === '') {
        callback(new Error(this.$t('LoginObj.PleaseAgain')))
      } else if (this.formList.password2 !== this.formList.password) {
        callback(new Error(this.$t('LoginObj.PleaseAgain')))
      } else {
        callback()
      }
    }
    return {
      formList: {
        captcha: null,
        password: null,
        password2: null
      },
      rules: {
        mobile: [{ validator: checkPhone, trigger: 'blur' }],
        password: [{ validator: validatePass, trigger: 'blur' }],
        password2: [{ validator: validatePass2, trigger: 'blur' }]
      },
      captchaImg: '', // 验证码图片
      isSendCode: false,
      isNumber: 60,
      radio: false
    }
  },
  created () {
    this.radio = false
  },
  methods: {
    toLogin () {
      this.$emit('toLogin')
    },
    clsoeRegist () {
      this.$emit('clsoeRegist')
    },
    regisTeredEvent () {
      if (this.registType === 1) {
        if (!this.radio) {
          this.$message.warning('请同意会员条款和免责声明')
          return
        }
      }
      // 注册

      this.$refs['formList'].validate((valid) => {
        if (valid) {
          this.formList.orgId = sessionStorage.getItem('orgId')
          if (this.registType === 1) {
            userRegister(this.formList).then((res) => {
              if (res.code === 0) {
                this.$message.success('注册成功')
                this.clsoeRegist()
              } else {
                this.$message.error('注册失败' + res.error)
              }
            })
          } else {
            forgotPassword(this.formList).then((res) => {
              if (res.code === 0) {
                this.$message.success('修改成功')
                this.clsoeRegist()
              } else {
                this.$message.error('修改失败' + res.error)
              }
            })
          }
        }
      })
    },
    verificationCodeEvent () {
      if (this.formList.mobile.match(/^1[34578]\d{9}$/) === null) {
        if (this.formList.mobile === '') {
          this.$message.error(this.$t('LoginObj.PleaseNumber'))
          return
        } else {
          this.$message.error(this.$t('LoginObj.PleaseNumber'))
          return
        }
      }
      this.isSendCode = true
      let times = setInterval(() => {
        this.isNumber--
        if (this.isNumber < 1) {
          this.isSendCode = false
          clearInterval(times)
          this.isNumber = 60
        }
      }, 1000)
      // 发送验证码
      if (this.formList.mobile) {
        messageAuthentication({
          mobilePhone: this.formList.mobile,
          orgId: sessionStorage.getItem('orgId'),
          templateId: 'SMS_T_NORMALCODE'
        }).then((res) => {
          console.log(res)
        })
      } else {
        this.$message.error('手机号不能为空')
      }
    },
    termsOfServiceEvent () {
      this.$emit('termsOfServiceEvent')
    }
  }
}
</script>

<style lang="scss" scoped>
.registeredPlane {
  position: fixed;
  top: 40%;
  left: 50%;
  display: flex;
  /* transition: trs; */
  transform: translate(-50%, -50%);
  z-index: 2000;
  background: white;
  border: 2px solid #d3d3d3;
  width: 720px;
  height: 468px;
  border-radius: 16px;
  .left {
    width: 300px;
    height: 468px;
    display: inline-block;
  }
  .curter {
    cursor: pointer;
  }
}
.registered {
  width: 390px;
  margin: 60px auto;
  .logo {
    text-align: center;
    margin-bottom: 36px;
  }
  .el-icon-close {
    cursor: pointer;
    position: absolute;
    top: 17px;
    right: 34px;
    font-size: 24px;
  }
  .icon-bk {
    display: inline-block;
    width: 40px;
    height: 40px;
    text-align: center;
    background: #853D3F;
    color: white;
  }
  .el-input {
    width: 350px;
  }
  .code-input {
    width: 250px;
  }
  .rightItem {
    display: flex;
    width: 100%;
    .verificationCode {
      width: 126px;
      height: 38px;
      float: right;
    }
    .verificationCodeBtn {
      float: right;
    }
  }
  .refresh {
    display: inline-block;
    margin-left: 15px;
  }
  .handle {
    width: 390px;
    background: #853D3F;
    color: white;
  }
  .foot-login {
    line-height: 40px;
    height: 40px;
    a {
      color: #c02020;
    }
    .forget-password {
      float: right;
      .el-radio {
        margin-right: 0;
      }
    }
  }
}
.tiketType_box {
  margin-top: 20px;
}
.marquee-title {
  float: left;
  width: 80px;
  line-height: 58px;
  height: 58px;
  margin-right: 18px;
}
.marquee-title span {
  display: inline-block;
  color: #ec2f2f;
  font-size: 12px;
  font-weight: bold;
  vertical-align: middle;
}
.marquee-title img {
  display: inline-block;
  width: 15px;
  height: 18px;
  margin-right: 6px;
  vertical-align: middle;
}
marquee {
  overflow: hidden;
  float: left;
  width: calc(100% - 98px);
  display: block;
  line-height: 58px;
  height: 58px;
  color: #666;
  font-size: 12px;
}

.noticeBtn {
  cursor: pointer;
  float: right;
  line-height: 40px;
  text-align: center;
  background-color: #ffb000;
  padding: 0 15px;
  border-radius: 20px;
  &:hover {
    opacity: 0.8;
  }
  .ico {
    display: inline-block;
    width: 18px;
    height: 20px;
    vertical-align: middle;
    background: url(../assets/images/notice.png) no-repeat;
    background-size: 100% 100%;
    margin-right: 10px;
  }
  .text {
    vertical-align: middle;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
  }
}

.buyticket {
  // margin-bottom: 40px;
  border-radius: 5px;
  .pane {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px 0px rgba(20, 34, 44, 0.15);
    padding: 30px 60px;
    .buyticket-box {
      overflow: hidden;
      .buyticket-div {
        overflow: hidden;
        margin-bottom: 19px;
        .title {
          float: left;
          font-size: 16px;
          color: #333;
          font-weight: bold;
          line-height: 44px;
          height: 44px;
        }
        .buyticket-right {
          overflow: hidden;
          padding-left: 100px;
          // height: 44px;
          .select-list {
            float: right;
            text-align: right;
            > span {
              display: inline-block;
              margin: 0 7px;
              width: 130px;
              height: 44px;
              background: rgba(246, 246, 246, 1);
              border-radius: 6px;
              font-size: 16px;
              color: #333;
              text-align: center;
              line-height: 44px;
              cursor: pointer;
              margin-bottom: 10px;
              > em {
                display: inline-block;
                width: 100%;
                height: 100%;
                line-height: 44px;
                border-radius: 6px;
                overflow: hidden;
                font-style: normal;
                &:hover {
                  opacity: 0.8;
                }
                &.active {
                  background: #241008;
                  color: #fff;
                }
                &.disable {
                  color: #cdcdcd;
                  cursor: no-drop;
                }
              }
            }
          }
          .select-btn {
            float: right;
            width: 130px;
            height: 44px;
            line-height: 44px;
            border-radius: 6px;
            .input-show {
              display: block;
              width: 100%;
              height: 100%;
              line-height: 44px;
              text-align: center;
              height: 44px;
              background: #f6f6f6;
              border-radius: 6px;
              font-size: 16px;
              color: #333;
              text-align: center;
              line-height: 44px;
              cursor: pointer;
              outline: none;
              text-align: center;
              &.active {
                background: #241008;
                color: #fff;
              }
              &:hover {
                opacity: 0.8;
              }
            }
            .picker-options {
              display: block;
              width: 100%;
              height: 44px;
              line-height: 44px;
              .el-input {
                width: 100% !important;
                background: #f6f6f6;
              }
            }
          }
        }
      }
      .buyticket-footer {
        overflow: hidden;
        display: flex;
        border-top: 1px solid #f6f6f6;
        padding-top: 29px;
        margin-top: 31px;
        .booking-notice {
          flex: 1;
          height: 58px;
          line-height: 58px;
          img {
            display: inline-block;
            width: 16px;
            height: 16px;
            vertical-align: middle;
            margin-right: 4px;
            cursor: pointer;
          }
          span {
            display: inline-block;
            font-size: 16px;
            color: #ec2f2f;
            vertical-align: middle;
            cursor: pointer;
          }
        }
        .booking-msg {
          flex: 1;
          overflow: hidden;
          line-height: 58px;
          text-align: right;
          .msg {
            display: inline-block;
            vertical-align: middle;
            font-size: 16px;
            color: #333;
            span {
              display: inline-block;
              color: #ff4400;
              margin: 0 12px;
            }
          }
          .payBtn {
            display: inline-block;
            width: 140px;
            height: 58px;
            line-height: 58px;
            text-align: center;
            font-size: 18px;
            border-radius: 6px;
            background: #241008;
            color: #fff;
            margin-left: 42px;
            margin-right: 7px;
            cursor: pointer;
            &.disable {
              background: #f6f6f6;
              cursor: no-drop;
              color: #cdcdcd;
            }
            &:hover {
              opacity: 0.8;
            }
          }
        }
      }
    }
    .dateSelect {
      margin-bottom: 16px;
      .label {
        font-weight: bold;
        line-height: 40px;
        margin-right: 15px;
      }
      .btn {
        display: inline-block;
        vertical-align: middle;
        min-width: 60px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        margin-right: 15px;
        border-radius: 15px;
        cursor: pointer;
        padding: 0 15px;
        box-sizing: border-box;
      }
      .btn.right {
        float: right;
        /* right: 20px; */
      }
      .btn.current {
        color: #fff;
        background-color: #21a4ff;
      }
    }
    .ticketDetail /deep/ .el-table::before {
      height: 0;
    }
    .ticketDetail /deep/ th.is-leaf {
      background-color: #21a4ff;
      color: #fff;
      border-bottom: 12px solid #fff;
    }
    .ticketDetail /deep/ th.is-leaf:nth-child(1) {
      background: url(../assets/images/border_th_l.png) #21a4ff no-repeat left;
    }
    .ticketDetail /deep/ th.is-leaf:nth-last-child(2) {
      background: url(../assets/images/border_th_r.png) #21a4ff no-repeat right;
    }
    .ticketDetail /deep/ td {
      background-color: #f7f7f7;
      border-bottom: 12px solid #fff;
      padding: 10px 0;
    }
    .ticketDetail /deep/ td .cell {
      font-weight: bold;
    }
    .ticketDetail /deep/ td:nth-child(1) {
      background: url(../assets/images/border_td_l.png) #f7f7f7 no-repeat left;
    }
    .ticketDetail /deep/ td:nth-last-child(2) {
      background: url(../assets/images/border_td_r.png) #f7f7f7 no-repeat right;
    }
  }
}

.reserveBtn {
  display: inline-block;
  height: 30px;
  line-height: 30px;
  color: #fff;
  font-weight: bold;
  padding: 0 20px;
  border-radius: 20px;
  background-color: #ffb000;
  cursor: pointer;
}
.reserveBtn:hover {
  background-color: #faab00;
}
.mb40 {
  margin-bottom: 40px;
}
.main-box {
  background: #ededed;
  padding-bottom: 35px;
}
.notice-dialog {
  .title {
    line-height: 20px;
    height: 20px;
    overflow: hidden;
    padding-left: 20px;
    position: relative;
    margin-bottom: 34px;
    &::before {
      position: absolute;
      top: 50%;
      width: 3px;
      height: 14px;
      background: rgba(191, 147, 48, 1);
      border-radius: 2px;
      margin-top: -7px;
      left: 8px;
      content: "";
    }
  }
  .notice {
    display: block;
    min-height: 300px;
    max-height: 400px;
    overflow-y: auto;
  }
  .btn {
    width: 130px;
    height: 44px;
    background: rgba(191, 147, 48, 1);
    border-radius: 6px;
    color: #fff;
    margin: 0 21px;
    &.cancal {
      background: #ccc;
      color: #333;
    }
  }
}
.dialog-login {
  iframe {
    display: block;
    width: 100%;
    height: 400px;
  }
}
</style>
